import { removeDuplicates } from '@atlassian/mpac-utils';
export const ANALYTICS_SCREEN_QUESTIONNAIRE_UI = 'partnerPrivacySecurityQuestionnaireUiScreen';
export const ANALYTICS_SCREEN_PREVIEW_PUBLISH_VIEW = 'partnerPrivacySecurityPreviewPublishScreen';
export const ANALYTICS_SCREEN_PREVIEW_DRAFT_VIEW = 'partnerPrivacySecurityPreviewDraftScreen';
export const ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB = 'overviewTab';
export const ANALYTICS_SCREEN_INTRODUCTION_MODAL_VIEW = 'privacySecurityIntroMessage';
export const ANALYTICS_OVERVIEW_GOTO_LEARN_ABOUT_P_N_S = 'overviewGotoLearnAboutPrivacyAndSecurity';
export const ANALYTICS_OVERVIEW_GOTO_P_N_S_TAB = 'overviewGotoPrivacyAndSecurityTab';
export const ANALYTICS_SAVE_AND_PREVIEW = 'saveAndPreview';
export const ANALYTICS_DISCARD_CHANGES = 'discardChanges';
export const ANALYTICS_DISCARD_CHANGES_CONFIRMATION_MODAL = 'discardChangesConfirmationModal';
export const ANALYTICS_SUBMIT_AND_PUBLISH = 'submitAndPublish';
export const ANALYTICS_EDIT_DRAFT = 'editDraft';
export const ANALYTICS_SUBMIT_AND_PUBLISH_CONFIRMATION_MODAL = 'submitAndPublishConfirmationModal';
export const ANALYTICS_EDIT_RESPONSES = 'editResponses';
export const ANALYTICS_CONTACT_SUPPORT = 'contactSupport';
export const ANALYTICS_PARTNER_EMAIL_ID = 'partnerEmailId';
export const ANALYTICS_QUESTIONNAIRE_UI_LINK = 'questionnaireUiLink';
export const ANALYTICS_QUESTIONNAIRE_UI_EMAIL = 'questionnaireUiEmail';
export const ANALYTICS_INTRODUCTION_UI_SKIP = 'privacySecuritySkipIntroModal';
export const ANALYTICS_INTRODUCTION_UI_UNDERSTOOD = 'privacySecurityUnderstoodIntroModal';
export const ANALYTICS_FEEDBACK_UI_YES = 'privacySecurityFeedbackCollectorYesButton';
export const ANALYTICS_FEEDBACK_UI_NO = 'privacySecurityFeedbackCollectorNoButton';
export const ANALYTICS_FEEDBACK_UI_SUBMIT = 'privacySecurityFeedbackCollectorSubmitButton';
export const ANALYTICS_EXPANDER_UI_CLICKED = 'privacySecurityExpandButton';
export const ANALYTICS_BANNER_UI_ELEMENT = 'questionnaireBannerLink';
export const ANALYTICS_PRIVACY_SECURITY_OVERVIEW_INTRO = 'privacySecurityOverviewIntro';
export const ANALYTICS_QUESTIONNAIRE_SUPPORT_TICKET_UI_LINK = 'questionnaireGoToSupportTicket';
export const ANALYTICS_PREVIEW_SUPPORT_TICKET_UI_LINK = 'privacySecurityPreviewGoToSupportTicket';
export const ANALYTICS_OVERVIEW_PRIVACY_POLICY_UI_LINK = 'privacyPolicyLink';
export const ANALYTICS_OVERVIEW_BUG_BOUNTY_LEARN_MORE_UI_LINK = 'bugBountyLearnMoreLink';
export const getUiErroredInputNames = formRef => {
  if (!formRef.current) {
    return;
  }
  const invalidInputs = Array.from(formRef.current.elements).filter(element => element.getAttribute('aria-invalid') === 'true');
  const invalidInputNames = invalidInputs.map(input => input.getAttribute('name'));

  // For radio buttons, each one has the same 'name' property
  return removeDuplicates(invalidInputNames);
};